<hyperscene-advanced [sceneOnly]="sceneOnly" [debugEnabled]="debug"></hyperscene-advanced>
